import Vue from 'vue'
import './plugins/axios'
// import 'default-passive-events'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './plugins/element.js'
import animated from 'animate.css'
import SlideVerify from 'vue-monoplasty-slide-verify'
// axios.defaults.withCredentials = true
// import Print from './plugins/print'
import Print from 'vue-print-nb'
import VueAMap from 'vue-amap';

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


Vue.use(SlideVerify);
Vue.use(VueAMap);
Vue.use(Print);

Vue.config.productionTip = false
// Vue.use(SlideVerify);
Vue.use(animated)
VueAMap.initAMapApiLoader({
  // 高德的key
  key: '140e77b93d7d030dc3ee0c83a55e8feb',
  // 插件集合
  plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch', 'AMap.Geolocation'],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4'

});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



